import React, { useState, useEffect } from 'react';
import api from '../services/api';
import {
    Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Typography, Chip, Dialog, DialogTitle, DialogContent, TextField, DialogActions, FormControl,
    InputLabel, Select, MenuItem, Grid
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

const Repairs = () => {
    const [repairs, setRepairs] = useState([]);
    const [open, setOpen] = useState(false);
    const [newRepair, setNewRepair] = useState({
        customer_id: '',
        store_id: 1, // Default store
        device_type: '',
        brand: '',
        model: '',
        problem_description: '',
        status: 'received'
    });

    const fetchRepairs = async () => {
        try {
            const response = await api.get('/repairs');
            if (response.data.success) {
                setRepairs(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching repairs", error);
        }
    };

    useEffect(() => {
        fetchRepairs();
    }, []);

    const handleCreate = async () => {
        try {
            await api.post('/repairs', newRepair);
            setOpen(false);
            fetchRepairs();
        } catch (error) {
            alert('Error creating repair');
        }
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="h4">Reparaciones</Typography>
                <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
                    Nueva Reparación
                </Button>
            </Box>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Ticket</TableCell>
                            <TableCell>Cliente</TableCell>
                            <TableCell>Dispositivo</TableCell>
                            <TableCell>Problema</TableCell>
                            <TableCell>Estado</TableCell>
                            <TableCell>Fecha</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {repairs.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell>{row.ticket_number}</TableCell>
                                <TableCell>{row.customer_first_name} {row.customer_last_name}</TableCell>
                                <TableCell>{row.brand} {row.model}</TableCell>
                                <TableCell>{row.problem_description}</TableCell>
                                <TableCell>
                                    <Chip label={row.status} color={row.status === 'completed' ? 'success' : 'warning'} />
                                </TableCell>
                                <TableCell>{new Date(row.created_at).toLocaleDateString()}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Nueva Reparación</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={6}>
                            <TextField fullWidth label="ID Cliente" type="number"
                                value={newRepair.customer_id} onChange={(e) => setNewRepair({ ...newRepair, customer_id: e.target.value })} />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Tipo</InputLabel>
                                <Select
                                    value={newRepair.device_type}
                                    label="Tipo"
                                    onChange={(e) => setNewRepair({ ...newRepair, device_type: e.target.value })}
                                >
                                    <MenuItem value="phone">Celular</MenuItem>
                                    <MenuItem value="tablet">Tablet</MenuItem>
                                    <MenuItem value="computer">Computadora</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField fullWidth label="Marca" value={newRepair.brand} onChange={(e) => setNewRepair({ ...newRepair, brand: e.target.value })} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField fullWidth label="Modelo" value={newRepair.model} onChange={(e) => setNewRepair({ ...newRepair, model: e.target.value })} />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth multiline rows={4} label="Descripción del Problema"
                                value={newRepair.problem_description} onChange={(e) => setNewRepair({ ...newRepair, problem_description: e.target.value })} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancelar</Button>
                    <Button onClick={handleCreate} variant="contained">Guardar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default Repairs;
